export default __webpack_public_path__ + "static/media/1960.dcbaad4b.png";